import * as React from "react";
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  logoHeader: {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '100%',
      minHeight: 85,
      marginRight: 25
  }
}));

const LogoHeader = props => {
  const classes  = useStyles();

  return(
    <Grid item className={clsx(classes.logoHeader, 'logoHeader')}/>
  );
}

export default LogoHeader;